export default __webpack_public_path__ + "static/media/05.42c6ffa8.png";